import React from "react";
import { Box, HStack, Flex, Text, Avatar, Stack } from "@chakra-ui/react";
import { BsStarFill } from "react-icons/bs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function Reviews() {
  return (
    <Box border="1px solid #c5c5c5" borderRadius={10}  my={8} pos="relative" >
      <Flex bg="#f7f7f7" justifyContent="space-between" p={4} fontWeight={"medium"} borderBottom={"1px solid #c5c5c5"} >
        <Text fontSize="18px">Reviews</Text>
        <Text color="brand.400" fontSize="13px">
          See all reviews
        </Text>
      </Flex>
      <Stack justifyContent="center" height={{base:"150px"}}>
        
      <Swiper
          slidesPerView={1}
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          
          loop={true}
          className="mySwiper gig-review-slider"
          modules={[Navigation]}
          navigation={true}
        >
          {
            ["1","2","3"].map(item=>{
              return (
                <SwiperSlide key={item}>
                  <Flex gap={{base:1,sm:4}} alignItems={{sm:"center"}} px={{base:10,sm:10}}>
                    <Avatar src="/images/freelancer/profiles/4.png" size={{base:"md",sm:"xl"}} />
                    <Stack>
                      <HStack alignItems={"center"} gap={1} >
                        <Text
                          fontSize={{ base: "12px", md:"16px", xl: "19px" }}
                          fontWeight={"medium"}
                        >
                          Nath2015
                        </Text>
                        <Flex
                          color={"#ffbe5b"}
                          gap={1}
                          alignItems="center"
                          fontSize={{ base: "12px", xl: "16px" }}
                        >
                          <BsStarFill />
                          <BsStarFill />
                          <BsStarFill />
                          <BsStarFill />
                          <BsStarFill />
                          <Text>5</Text>
                        </Flex>
                      </HStack>
                      <Text
                        fontWeight={"semibold"}
                        color="gray.500"
                        fontSize={{ base: "10px",sm:"13px", xl: "16px" }}
                        w="95%"
                      >
                        I asked for some logos for my new publishing company and I am very
                        pleased with the results
                      </Text>
                    </Stack>
                  </Flex>
                </SwiperSlide>
              )
            })
          }
          </Swiper>
      </Stack>
    </Box>
  );
}
